





























import { defineComponent, ref, computed, Ref, isVue2 } from 'vue-demi';
import type Props from 'zk-date-picker/dist/DateTimePicker/Props';
import theme from '@zk/theme/lib/variables.scss';
import { DateTimePicker } from 'zk-date-picker';

export default defineComponent({
  name: 'DueDate',
  components: {
    DateTimePicker
  },
  extends: DateTimePicker,
  props: {
    emptyText: {
      type: String,
      default: '未知'
    },
    clearFixed: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    cleartext: {
      type: String,
      default: '清空'
    },
    icon: {
      type: String,
      default: 'zkicon icondata'
    },
    ...(DateTimePicker.props as typeof Props)
  },
  setup(props, { emit }) {
    const options = computed(() => {
      return {
        ...props
      };
    });
    const date = computed(() => props.value);
    const isVisible = ref<boolean>(false);

    const datePickerRef: Ref<typeof DateTimePicker | null> = ref(null);

    const show = () => {
      datePickerRef.value.show();
    };
    const hide = () => {
      datePickerRef.value.hide();
    };
    const clear = () => {
      datePickerRef.value.clear();
    };
    const onInput = (val:number) =>{
      if (isVue2){
        emit('input', val);
      } else {
        emit('update:value', val);
      }
    };
    const onVisible = (visible: boolean) => {
      isVisible.value = visible;
      emit('visible-change', visible);
    };
    return {
      show,
      hide,
      clear,
      options,
      date,
      datePickerRef,
      onVisible,
      isVisible,
      onInput
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
